export default "__VITE_ASSET__BbCIVMKe__"